// Placeholder data sources. Swap the two functions below for real API
// calls (e.g. a places-autocomplete endpoint / an LLM prompt-suggestion
// endpoint) without touching any component code.

const POPULAR_LOCATIONS = [
    "Sarjapur Road, Bengaluru",
    "Whitefield, Bengaluru",
    "Electronic City, Bengaluru",
    "Indiranagar, Bengaluru",
    "HSR Layout, Bengaluru",
    "Hosur Road, Bengaluru",
    "Kasavanahalli, Bengaluru",
    "Attibele Road, Bengaluru",
    "Gattahalli, Bengaluru",
];

const AI_PROMPT_IDEAS = [
    "3 BHK villas under 1.5 Cr in Sarjapur",
    "RERA approved apartments near Whitefield",
    "Holiday homes with a pool",
    "Compare Kasavanahalli vs Sarjapur pricing",
    "2 BHK apartments ready to move in",
];

const RECENT_SEARCH_KEY = "gm.recentLocationSearches";
const MAX_RECENT = 5;

export function getRecentLocationSearches() {
    try {
        const raw = window.localStorage.getItem(RECENT_SEARCH_KEY);
        return raw ? JSON.parse(raw) : [];
    } catch {
        return [];
    }
}

export function pushRecentLocationSearch(value) {
    try {
        const trimmed = value.trim();
        if (!trimmed) return getRecentLocationSearches();
        const existing = getRecentLocationSearches().filter(
            (v) => v.toLowerCase() !== trimmed.toLowerCase()
        );
        const next = [trimmed, ...existing].slice(0, MAX_RECENT);
        window.localStorage.setItem(RECENT_SEARCH_KEY, JSON.stringify(next));
        return next;
    } catch {
        return getRecentLocationSearches();
    }
}

/**
 * Returns a normalized suggestion list: [{ id, label, type }]
 * type is one of "recent" | "location" | "ai"
 */
export function getManualSuggestions(query, recentSearches) {
    const trimmed = query.trim();

    if (!trimmed) {
        return recentSearches.map((label, i) => ({
            id: `recent-${i}`,
            label,
            type: "recent",
        }));
    }

    const q = trimmed.toLowerCase();
    return POPULAR_LOCATIONS.filter((loc) => loc.toLowerCase().includes(q))
        .slice(0, 6)
        .map((label, i) => ({ id: `loc-${i}`, label, type: "location" }));
}

export function getAiSuggestions(query) {
    const trimmed = query.trim();

    if (!trimmed) {
        return AI_PROMPT_IDEAS.map((label, i) => ({
            id: `prompt-${i}`,
            label,
            type: "ai",
        }));
    }

    const q = trimmed.toLowerCase();
    return AI_PROMPT_IDEAS.filter((p) => p.toLowerCase().includes(q))
        .slice(0, 5)
        .map((label, i) => ({ id: `prompt-${i}`, label, type: "ai" }));
}